module.exports = __webpack_public_path__ + "media/media/about/comm-2-5450c1eaaf751e862f6bf608ed91d182.png";